<template>
  <ValidationObserver ref="forgotPasswordFormValidator">
    <form
      @submit.prevent="submitForgotPassword"
      data-qa="por-forgot-password--form"
    >
      <div class="por-forgot-password--form-item">
        <Input
          id="email"
          validation-rules="required|email"
          :input-model.sync="email"
          :label-text="$t('common_email_label')"
          :placeholder-text="$t('common_email_placeholder')"
          input-type="email"
          :error-text="`${$t('common_validEmail_text')}.`"
          data-qa="por-forgot-password--email-input" />
      </div>
      <div class="por-forgot-password--form-item">
        <b-button
          size="is-medium"
          type="is-primary"
          expanded
          :disabled="isSubmitting"
          :loading="isSubmitting"
          tag="input"
          native-type="submit"
          :value="$t('forgotPasswordForm_requestMail_text')"
          data-qa="por-forgot-password--submit" />
        <b-button tag="router-link"
          class="is-fullwidth por-standard-top-spacing"
          :to="{ name: 'login' }"
          data-qa="por-forgot-password--login-link"
          type="is-text">
          {{ $t('forgotPassword_LoginLink_button') }}
        </b-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { Auth } from '@aws-amplify/auth'

import { track } from '@/services/tracking'
import { successMessageMapping, errorMessageMapping } from '@/helpers/message-mapping'
import { isUnconfirmedUserPasswordReset } from '@/helpers/error-mapping'
import trackErrors from '@/helpers/track-errors'
import router from '@/router'

import Input from '@/components/inputs/input'

export default {
  name: 'ForgotPasswordForm',
  components: {
    Input
  },
  data () {
    return {
      email: '',
      submitStatus: null
    }
  },
  computed: {
    validEmail: function () {
      return this.email.toLowerCase()
    },
    isSubmitting: function () {
      return this.submitStatus === 'PENDING'
    }
  },
  methods: {
    async submitForgotPassword () {
      track({ name: 'button tap', params: { module: 'forgot password', description: 'forgot password button' } })

      this.submitStatus = 'PENDING'

      this.$refs.forgotPasswordFormValidator.validate().then(async success => {
        if (!success) {
          this.submitStatus = 'ERROR'
          trackErrors(this.$refs.forgotPasswordFormValidator, 'forgot password')
          return
        }

        try {
          this.$store.dispatch('user/setCredentials', { email: this.validEmail, password: '' })
          await Auth.forgotPassword(this.validEmail)

          let successMessage = successMessageMapping('request-password')
          successMessage = this.$t(successMessage, { email: this.validEmail })

          track({ name: 'forgot password success', params: { module: 'forgot password' } })

          if (window.newrelic) {
            window.newrelic.addPageAction('forgotpassword')
          }
          this.submitStatus = 'SUBMITTED'

          router.push({ name: 'request-password' })
          this.$store.dispatch('site/setMessage', {
            message: successMessage,
            type: 'success'
          })
        } catch (error) {
          let errorMessage = errorMessageMapping(error.message)
          this.submitStatus = null
          if (isUnconfirmedUserPasswordReset(error)) {
            errorMessage = 'To reset your password, you first need to verify your email address. We\'ve sent you an email to do this, so please check your inbox and follow the instructions.'
            await Auth.resendSignUp(this.validEmail)
            this.$store.dispatch(
              'site/setMessage',
              {
                title: 'Please note:',
                message: errorMessage,
                type: 'warning'
              })
            router.push({ name: 'email-verification' })
          } else {
            this.$store.dispatch('site/setMessage', { message: errorMessage, type: 'danger' })
          }
          track({ name: 'error', params: { module: 'forgot password', error_message: errorMessage } })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
$por-forgot-password--form-item-margin-top: 16px;

.por-forgot-password--form-item + .por-forgot-password--form-item,
.por-standard-top-spacing {
  margin-top: $por-forgot-password--form-item-margin-top;
}

.forgot-password-button {
  width: 100%;
  display: inline-block;
  margin-top: $por-forgot-password--form-item-margin-top;
}
</style>
